module.exports = __webpack_public_path__ + "img/address-add@2x.f0af24db.png";